export const isAgentTypeOrdering = (agentType?: string): boolean => {
  if (!agentType) return false;
  const agentTypeLower = agentType.toLowerCase();
  if (agentTypeLower.includes("pickup")) return true;
  if (agentTypeLower.includes("catering")) return true;
  return false;
};

export const isAgentTypeDelivery = (agentType?: string): boolean => {
  if (!agentType) return false;
  const agentTypeLower = agentType.toLowerCase();
  if (agentTypeLower.includes("delivery")) return true;
  if (agentTypeLower.includes("catering")) return true;
  return false;
};

export const isStreamOrderingAgent = (
  agentType?: string,
  isStream?: boolean
): boolean => {
  if (!agentType) return false;
  return isAgentTypeOrdering(agentType) && isStream === true;
};

export const isSquareOrderingAgent = (
  agentType?: string,
  isSquare?: boolean
): boolean => {
  if (!agentType) return false;
  return isAgentTypeOrdering(agentType) && isSquare === true;
};

export const isNonStreamOrderingAgent = (
  agentType?: string,
  isStream?: boolean
): boolean => {
  if (!agentType) return false;
  return isAgentTypeOrdering(agentType) && !isStream;
};
